'use strict';

( function ( $ ) {
	$( '.load-more-comments' ).on( 'click', function () {
		$( '.single-post__comments-comment.hide' ).show();
		$( this ).hide();
	} );
} )( jQuery );
